import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'esc-privacy-dialog',
  templateUrl: './privacy-dialog.component.html',
  styleUrls: ['./privacy-dialog.component.scss']
})
export class PrivacyDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
